import * as React from "react";
import { List } from "react-admin";
import { ExcelExport } from "../../../../Helper/ExportExcel";
import FilterToolbar from "../../../../Components/FiltersToolbar/FilterToolbar";
import { DefaultPerPageSize } from "../../../../Constants/Constant";
import { FilterInputType, FilterTypes } from "../../../../Enums/FilterTypes";
import { DataGridColumns } from "./DataGridColumns";
import { Drawer, Grid, makeStyles } from "@material-ui/core";
import RequestOrderNotes from "../RequestOrderNotes";
import { RemarkTypes } from "../../../../../src/Enums/RemarkTypes";
import { WorkShops } from "../../../../Constants/Constant";
import { WoStatus } from "../../../../Constants/Constant";
import { useVerifyPermission } from "@airborne/react-admin";

export const useStyles = makeStyles(theme => ({
  drawerPaper: {
    width: "20%",
  },
}));

export const Status15 = props => {
  useVerifyPermission("customroutes", "tobeshop.read");
  const [isMatchCreate, setIsMatchCreate] = React.useState(false);
  const [requestRemark, setRequestRemark] = React.useState<any>({});
  const classes = useStyles();

  const ExportToExcel = data => {
    ExcelExport(
      [
        {
          header: "Ref No",
          key: "Ref No",
        },
        {
          header: "Customer",
          key: "Customer",
        },
        {
          header: "Customer PO",
          key: "Customer PO",
        },
        {
          header: "PN",
          key: "PN",
        },
        {
          header: "PN Description",
          key: "PN Description",
        },
        {
          header: "SN",
          key: "SN",
        },
        {
          header: "WO",
          key: "WO",
        },
        {
          header: "RO",
          key: "RO",
        },
        {
          header: "Work Shop",
          key: "Work Shop",
        },
        {
          header: "Wo Inprogress Status",
          key: "Wo Inprogress Status",
        },
        {
          header: "Requested Delivery Date",
          key: "Requested Delivery Date",
        },
        {
          header: "Wo Created Date",
          key: "Wo Created Date",
        },
        {
          header: "Shop Remarks",
          key: "Shop Remarks",
        },
        {
          header: "Rdd Delayed",
          key: "Rdd Delayed",
        },
      ],
      data.map(v => [
        v.refNo,
        v.customer,
        v.customerPo,
        v.pn,
        v.pnDescription,
        v.sn,
        v.wo,
        v.ro,
        v.workShop,
        v.woInprogressStatus,
        v.requestedDeliveryDate,
        v.woCreatedDate,
        v.shopRemark,
        v.isRddDelayed,
      ]),
      "Shop List"
    );
  };

  const remarkAddClick = record => {
    setIsMatchCreate(true);
    setRequestRemark(record);
  };

  const handleClose = () => {
    setIsMatchCreate(false);
  };

  return (
    <>
      <List
        {...props}
        title={"Shop"}
        hasCreate={false}
        exporter={ExportToExcel}
        resource="requestorders/shop"
        basePath="shop"
        hasBulkActions={false}
        perPage={DefaultPerPageSize}
        filters={
          <FilterToolbar
            dataSource={[
              {
                source: "refNo",
                inputType: FilterInputType.Text,
                label: "Ref No",
              },
              {
                source: "customerPo",
                inputType: FilterInputType.Text,
                label: "Customer PO",
              },
              {
                source: "pn",
                inputType: FilterInputType.Text,
                label: "PN",
              },
              {
                source: "pnDescription",
                inputType: FilterInputType.Text,
                label: "PN DESCRIPTION",
              },
              {
                source: "sn",
                inputType: FilterInputType.Text,
                label: "SN",
              },
              {
                source: "workShop",
                inputType: FilterInputType.Select,
                label: "Work Shop",
                filterTypeChangeDisable: true,
                filterType: FilterTypes.Equals,
                choices: WorkShops,
                optionValue: "value",
                optionText: "shop",
              },
              {
                source: "woInprogressStatus",
                inputType: FilterInputType.Select,
                label: "Wo INPROGRESS STATUS",
                filterTypeChangeDisable: true,
                filterType: FilterTypes.Equals,
                choices: WoStatus,
                optionValue: "value",
                optionText: "woStatus",
              },
              {
                source: "wo",
                inputType: FilterInputType.Number,
                filterType: FilterTypes.Equals,
                label: "WO",
              },
              {
                source: "ro",
                inputType: FilterInputType.Number,
                filterType: FilterTypes.Equals,
                label: "RO",
              },
            ]}
          />
        }
      >
        <DataGridColumns remarkAddClick={remarkAddClick} />
      </List>
      {isMatchCreate && (
        <Grid item xs={3}>
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="persistent"
            open={isMatchCreate}
            anchor="right"
            onClose={handleClose}
          >
            {isMatchCreate ? (
              <RequestOrderNotes
                onCancel={handleClose}
                request={requestRemark}
                resource="requestremarks"
                basePath="requestremarks"
                remarkType={RemarkTypes.ShopNote}
              />
            ) : null}
          </Drawer>
        </Grid>
      )}
    </>
  );
};

export default Status15;
